module.exports = __webpack_public_path__ + "ac0da684708ca89644d8dc166f5c4a38.MP3";